/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Selections,
} from '../models/index';
import {
    SelectionsFromJSON,
    SelectionsToJSON,
} from '../models/index';

/**
 * 
 */
export class SelectionsApi extends runtime.BaseAPI {

    /**
     * Get all selections available
     */
    async getAllSelectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Selections>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/selections`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectionsFromJSON));
    }

    /**
     * Get all selections available
     */
    async getAllSelections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Selections>> {
        const response = await this.getAllSelectionsRaw(initOverrides);
        return await response.value();
    }

}
